/**
 * Production Configuration
 * Centralized configuration for production environment
 */

export const productionConfig = {
  // Environment
  isProduction: process.env.NODE_ENV === 'production',
  isDevelopment: process.env.NODE_ENV === 'development',

  // Error Logging
  errorLogging: {
    enabled: true,
    endpoint: '/api/logs',
    maxRetries: 3,
    batchSize: 10,
    flushInterval: 5000
  },

  // Performance Monitoring
  performance: {
    enabled: true,
    sampleRate: 0.1, // 10% of users
    metricsEndpoint: '/api/metrics'
  },

  // Feature Flags
  features: {
    analytics: false,
    debugMode: false,
    experimentalFeatures: false,
    betaFeatures: false
  },

  // PDF Processing
  pdf: {
    maxFileSize: 50 * 1024 * 1024, // 50MB
    maxPages: 1000,
    timeout: 30000, // 30 seconds
    supportedFormats: ['application/pdf']
  },

  // UI Configuration
  ui: {
    animationDuration: 300,
    debounceDelay: 300,
    throttleDelay: 100,
    maxNotifications: 5,
    notificationTimeout: 5000
  },

  // Security
  security: {
    contentSecurityPolicy: true,
    xssProtection: true,
    frameOptions: 'DENY'
  },

  // Caching
  cache: {
    enabled: true,
    maxAge: 3600000, // 1 hour
    maxSize: 100 // 100 items
  }
};

export default productionConfig;
